"use strict";

// Galleri med lightbox (components/gallery.twig).
// Hvert [data-gallery] er selvstændigt, så flere gallerier på samme side virker.
// Bruger native <dialog>: Esc lukker, fokus fanges i dialogen og returneres ved luk.

// eslint-disable-next-line no-unused-vars
const initGallery = () => {
  document.querySelectorAll("[data-gallery]").forEach(setupGallery);
};
const setupGallery = root => {
  const items = [...root.querySelectorAll("[data-gallery-item]")];
  const dialog = root.querySelector(".gallery-dialog");
  if (!dialog || items.length === 0) {
    return;
  }
  const stage = dialog.querySelector("[data-gallery-stage]");
  const image = dialog.querySelector("[data-gallery-image]");
  const spinner = dialog.querySelector("[data-gallery-spinner]");
  const counter = dialog.querySelector("[data-gallery-counter]");
  const prevButton = dialog.querySelector("[data-gallery-prev]");
  const nextButton = dialog.querySelector("[data-gallery-next]");
  const closeButton = dialog.querySelector("[data-gallery-close]");
  let current = 0;
  let lastTrigger = null;
  const setSource = (img, item) => {
    const srcset = item.dataset.fullSrcset;
    if (srcset) {
      img.srcset = srcset;
    } else {
      img.removeAttribute("srcset");
    }
    img.src = item.dataset.full;
  };

  // Hent naboerne i baggrunden, så næste/forrige vises med det samme
  const preload = index => {
    const item = items[(index + items.length) % items.length];
    const img = new Image();
    img.sizes = "100vw";
    setSource(img, item);
  };
  const show = index => {
    current = (index + items.length) % items.length;
    const item = items[current];
    image.classList.remove("is-loaded");
    spinner.classList.remove("is-hidden");
    image.alt = "Billede ".concat(current + 1, " af ").concat(items.length);
    setSource(image, item);
    counter.textContent = "".concat(current + 1, " / ").concat(items.length);

    // Billedet kan allerede ligge i cachen
    if (image.complete && image.naturalWidth > 0) {
      onLoaded();
    }
    if (items.length > 1) {
      preload(current + 1);
      preload(current - 1);
    }
  };
  const onLoaded = () => {
    spinner.classList.add("is-hidden");
    image.classList.add("is-loaded");
  };
  const open = (index, trigger) => {
    lastTrigger = trigger !== null && trigger !== void 0 ? trigger : null;
    show(index);
    document.documentElement.style.overflow = "hidden";
    dialog.showModal();
  };
  const close = () => {
    if (dialog.open) {
      dialog.close();
    }
  };
  image.addEventListener("load", onLoaded);
  image.addEventListener("error", onLoaded);
  items.forEach((item, index) => {
    item.addEventListener("click", () => open(index, item));
  });
  prevButton === null || prevButton === void 0 || prevButton.addEventListener("click", () => show(current - 1));
  nextButton === null || nextButton === void 0 || nextButton.addEventListener("click", () => show(current + 1));
  closeButton === null || closeButton === void 0 || closeButton.addEventListener("click", close);

  // Klik ved siden af billedet (på baggrunden) lukker
  stage.addEventListener("click", e => {
    if (e.target === stage) {
      close();
    }
  });

  // Gælder kun, mens netop denne dialog er åben
  dialog.addEventListener("keydown", e => {
    if (e.key === "ArrowRight") {
      e.preventDefault();
      show(current + 1);
    } else if (e.key === "ArrowLeft") {
      e.preventDefault();
      show(current - 1);
    }
  });

  // Swipe på mobil
  let touchStartX = null;
  let touchStartY = null;
  stage.addEventListener("touchstart", e => {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, {
    passive: true
  });
  stage.addEventListener("touchend", e => {
    if (touchStartX === null) {
      return;
    }
    const dx = e.changedTouches[0].clientX - touchStartX;
    const dy = e.changedTouches[0].clientY - touchStartY;
    touchStartX = null;

    // Kun vandrette swipes over 50 px
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
      show(current + (dx < 0 ? 1 : -1));
    }
  }, {
    passive: true
  });

  // Esc og close() ender begge her
  dialog.addEventListener("close", () => {
    var _lastTrigger;
    document.documentElement.style.overflow = "";
    image.removeAttribute("srcset");
    image.removeAttribute("src");
    (_lastTrigger = lastTrigger) === null || _lastTrigger === void 0 || _lastTrigger.focus();
  });
};
initGallery();
//# sourceMappingURL=gallery.js.map